import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { uploadPdfReport } from "@/redux/actions/testKitActions"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"

const UploadPdf = () => {

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [formState, setFormState] = useState({
        report_file: null,
    })
    const [error, setError] = useState<string>("")

    const params = useParams()
    const dispatch: any = useDispatch()

    const handleFileChange = (key: string, value: File | null) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value,
        }))
    }

    const validateInput = () => {
        let errorMessage = ""
        if (!formState.report_file || formState.report_file === "") {
            errorMessage = 'Report file is required'
        } else {
            errorMessage = ''
        }
        setError(errorMessage)
        return errorMessage
    }

    const handleSubmit = () => {
        const errorMessage = validateInput()
        if (!errorMessage) {
            const payload = {
                "result_file": formState.report_file,
            }
            dispatch(uploadPdfReport(Number(params.id), payload, () => setIsOpen(false)))
        }
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="secondary">Upload Report</Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Upload Report</DialogTitle>
                    <DialogDescription>
                        Upload the Report file of the test kit.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    {error && <div className="grid grid-cols-4 items-center gap-4">
                        <div className="col-span-1"></div>
                        <div className="col-span-3">
                            <p className="text-red-500 text-sm">{error}</p>
                        </div>
                    </div>}
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="report_file" className="text-right">
                            Report File
                        </Label>
                        <Input
                            id="report_file"
                            name="report_file"
                            className="col-span-3"
                            type="file"
                            accept=".pdf"
                            onChange={(e) => handleFileChange("report_file", e.target.files && e.target.files[0])}
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button type="submit" onClick={() => handleSubmit()}>Upload</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default UploadPdf
